import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { StyledNominaEmailDialog } from "../../../../styled/Personal";

const initialValues = {
  email: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Debe escribir un formato de email válido")
    .required("Este campo es obligatorio"),
});

export default function  NominaEmailDialog({ handleSubmit, open, handleClose }) {

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Enviar certificado por Email</DialogTitle>
      <StyledNominaEmailDialog.ContainerBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values.email);
            handleClose();
          }}
        >
          <Form>
            <StyledNominaEmailDialog.FormikInput>
              <FormikTextField
                fullWidth={true}
                id="email"
                name="email"
                type="text"
                label="Email"
              />
            </StyledNominaEmailDialog.FormikInput>
            <StyledNominaEmailDialog.ContainerButtons>
              <Button type="button" onClick={handleClose}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Enviar
              </Button>
            </StyledNominaEmailDialog.ContainerButtons>
          </Form>
        </Formik>
      </StyledNominaEmailDialog.ContainerBody>
    </Dialog>
  );
}
